<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card>
            <v-card-title>
                <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="data" :search="search">
                <template v-slot:item="dataDetail">
                    <tr>
                        <td>{{dataDetail.item.cus_code}}</td>
                        <td>{{dataDetail.item.customer_name}}</td>
                        <td>{{dataDetail.item.tel}}</td>
                        <td>{{dataDetail.item.addess}}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
    </div>
</div>
</template>

<script>
import contentcustomer from '@/api/content/contentcustomer/contentcustomer.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            search: '',
            headers: [{
                    text: 'รหัสลูกค้า',
                    align: 'start',
                    value: 'cus_code',
                },
                {
                    text: 'ชื่อ',
                    value: 'customer_name'
                },
                {
                    text: 'เบอร์โทร',
                    value: 'tel'
                },
                {
                    text: 'ที่อยู่',
                    value: 'addess'
                },
            ],
            data: [],
        }
    },
    methods: {
        async customerList() {
            this.loading_page = true
            this.data = []
            contentcustomer.customerList().then((response) => {
                if (response.data.successful === true) {
                    response.data.customer.forEach((detail) => {
                        this.data.push({
                            id:detail.id,
                            cus_code:detail.cus_code,
                            customer_name:detail.customer_name,
                            tel:detail.tel,
                            addess:`${detail.addess} ${detail.district} ${detail.amphoe} ${detail.province} ${detail.zipcode}`,
                        })
                    })
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        }
    },
    mounted() {
        this.customerList()
    }
}
</script>
